import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Box } from "@mui/material";
import useOutsideClick from "hooks/useOutsideClick";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  StyledDropDownContainer,
  StyledDropDownText,
} from "features/metadesk/settings/IntegrationPage/components/integrationComponent.styles";
import Button, { SIZE } from "@metacrm/metacrm-material-ui/dist/Button";

export default function CustomButtonDropdown({ btnText = "", options = [] }) {
  const { formatMessage } = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useOutsideClick(() => setIsOpen(false));

  return (
    <Box ref={ref} position="relative">
      <Button
      
        size={SIZE.MEDIUM}
        onClick={() => setIsOpen(true)}
        style={{ marginLeft: "8px", padding: "16px" }}
      >
        {btnText
          ? btnText
          : formatMessage({ id: "websiteTraffic.dropdown.actions" })}
        <KeyboardArrowDownIcon />
      </Button>
      {isOpen && (
        <StyledDropDownContainer style={{ position: "absolute", zIndex: 100 }}>
          <Box fontSize={12} color="#555">
            {options.map((item, index) => (
              <StyledDropDownText key={index} onClick={item.action}>
                {item.label}
              </StyledDropDownText>
            ))}
          </Box>
        </StyledDropDownContainer>
      )}
    </Box>
  );
}
